import React from 'react';
import { Width } from '@extensions/AttributePanel/components/attributes/Width';
import { BackgroundColor } from '@extensions/AttributePanel/components/attributes/BackgroundColor';
import { VerticalAlign } from '@extensions/AttributePanel/components/attributes/VerticalAlign';
import { Collapse, Grid } from '@arco-design/web-react';
import { AttributesPanelWrapper } from '@extensions/AttributePanel/components/attributes/AttributesPanelWrapper';
import { ClassName } from '../../attributes/ClassName';
import { CollapseWrapper } from '../../attributes/CollapseWrapper';

export function Group() {
  return (
    <CollapseWrapper defaultActiveKey={['0', '1', '4']} style={{ padding: 0 }}>
        <Collapse.Item name='0' header={t('Dimension')}>
          <div className="px-2 py-3">
            <Width />
            <VerticalAlign hiddenValues={['middle']} />
          </div>
        </Collapse.Item>
        <Collapse.Item name='1' header={t('Background')}>
          <div className="px-2 py-3">
            <BackgroundColor />
          </div>
        </Collapse.Item>
        <Collapse.Item name='4' header={t('Extra')}>
          <div className="px-2 py-3">
            <ClassName />
          </div>
        </Collapse.Item>
      </CollapseWrapper>
  );
}
